exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-box[data-v-83f6b8a0]{width:90px;height:90px}.icon-box svg[data-v-83f6b8a0]{width:26px;height:26px}", ""]);

// exports
